import { createApp } from 'vue';
import App from './App.vue';
import EventBus from '@/services/EventBus.js';
import router from './router';
// import AuthenticationService from './services/AuthenticationService';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXmark, faDownload, faTrash, faPen, faBan, faBook, faLock, faLockOpen, faAngleUp, faBoxArchive, faCheck, faCopy, faCircleExclamation, faPlus, faBars } from '@fortawesome/free-solid-svg-icons';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';

import {LicenseManager} from "ag-grid-enterprise";

import { createBootstrap } from 'bootstrap-vue-next/plugins/createBootstrap'
import {
  BButton,

  BCard,
  BCardBody,
  BCardFooter,
  BCardHeader,

  BCollapse,

  BCol,
  BRow,

  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BFormTextarea,

  BTab,
  BTabs
} from 'bootstrap-vue-next'
import { vBTooltip } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

library.add(faXmark,faDownload,faTrash,faPen,faBan,faBook,faLock,faLockOpen,faAngleUp,faSquare,faSquareCheck,faBoxArchive,faCheck,faCopy,faCircleExclamation,faPlus,faBars);

LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID);

window._ = require('lodash');

const app = createApp(App);

app.use(router);
app.use(createBootstrap());

app.component('BButton', BButton)

app.component('BCard', BCard)
app.component('BCardBody', BCardBody)
app.component('BCardFooter', BCardFooter)
app.component('BCardHeader', BCardHeader)

app.component('BCollapse', BCollapse)

app.component('BCol', BCol)
app.component('BRow', BRow)

app.component('BForm', BForm)
app.component('BFormCheckbox', BFormCheckbox)
app.component('BFormFile', BFormFile)
app.component('BFormGroup', BFormGroup)
app.component('BFormInput', BFormInput)
app.component('BFormInvalidFeedback', BFormInvalidFeedback)
app.component('BFormSelect', BFormSelect)
app.component('BFormTextarea', BFormTextarea)

app.component('BTab', BTab)
app.component('BTabs', BTabs)

app.component('FontAwesomeIcon', FontAwesomeIcon);

app.directive('b-tooltip', vBTooltip)

let highestZIndex = 100;
let activeDraggable = null;

app.directive('draggable', {
  mounted(el) {
    let startX
    let startY
    let initialMouseX
    let initialMouseY

    el.style.zIndex = highestZIndex++
    el.style.position = 'absolute'

    function mousemove(event) {
      if (
        event.clientX >= 10 &&
        event.clientX <= window.innerWidth - 10
      ) {
        const dx = event.clientX - initialMouseX
        el.style.left = `${startX + dx}px`
      }

      if (
        event.clientY >= 50 &&
        event.clientY <= window.innerHeight - 50
      ) {
        const dy = event.clientY - initialMouseY
        el.style.top = `${startY + dy}px`
      }

      return false
    }

    function mouseup() {
      document.body.classList.remove('disable-text-selection')
      document.removeEventListener('mousemove', mousemove)
      document.removeEventListener('mouseup', mouseup)
    }

    function mousedownHandle(event) {
      document.body.classList.add('disable-text-selection')

      startX = el.offsetLeft
      startY = el.offsetTop
      initialMouseX = event.clientX
      initialMouseY = event.clientY

      document.addEventListener('mousemove', mousemove)
      document.addEventListener('mouseup', mouseup)

      return false
    }

    function resizeHandle() {
      if (el.style.left !== '') {
        if (window.innerWidth < parseInt(el.style.left, 10) + 40) {
          el.style.left = `${window.innerWidth - 60}px`
        }

        if (
          window.innerHeight < parseInt(el.style.top, 10) + 30 &&
          window.innerHeight > 80
        ) {
          el.style.top = `${window.innerHeight - 50}px`
        }
      }
    }

    function focusHandle() {
      if (activeDraggable === el) {
        return
      }

      activeDraggable = el
      el.style.zIndex = highestZIndex++
    }

    const dragHandle = el.children[0]

    if (dragHandle) {
      dragHandle.addEventListener('mousedown', mousedownHandle)
    }

    window.addEventListener('resize', resizeHandle)
    el.addEventListener('mousedown', focusHandle)

    /*
     * Save the handlers on the element so they can be removed when
     * the directive is unmounted.
     */
    el.__draggableCleanup = () => {
      document.removeEventListener('mousemove', mousemove)
      document.removeEventListener('mouseup', mouseup)
      window.removeEventListener('resize', resizeHandle)
      el.removeEventListener('mousedown', focusHandle)

      if (dragHandle) {
        dragHandle.removeEventListener('mousedown', mousedownHandle)
      }
    }
  },

  unmounted(el) {
    el.__draggableCleanup?.()
    delete el.__draggableCleanup
  }
});

// Set element 
EventBus.on('set-topmost-element', (el) => {
  if ((el instanceof Element) && (el?.style))
    el.style.zIndex = highestZIndex++;
  else
    console.warn('Argument is no DOM element. Type: ', typeof el)
});

app.mount('#app');
